import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { ActionButton as FluentUIActionButton } from '@fluentui/react';

import { BaseButton } from '../BaseButton';
import { IButtonImplProps } from '../BaseButton.types';

export const ActionButton = (props: IButtonImplProps) => <BaseButton componentAs={FluentUIActionButton} {...props} />;
